module.exports = __webpack_public_path__ + "static/media/patent_kr.6fde758f.8e77907d.jpg";